module.exports = __webpack_public_path__ + "img/cat_dl.ae05c298.jpg";